import { webviewRuntime } from 'modules/shared/page-enhancers/src/utils/webview-runtime'
import { useExperiment } from 'shared/experiment'

const LUCY_CHAT_EXPERIMENT = 'engineering-cj-core-lucy-web-chat'

export function useWhatsAppSupportButtonVisibility(subjectId: string, isOneStone: boolean): boolean {
  const showFullExperience = !webviewRuntime.isWebView()
  const { isFeatureFlagEnabled: isLucyEnabled } = useExperiment(subjectId, LUCY_CHAT_EXPERIMENT)
  const isLucyActive = isLucyEnabled && isOneStone

  return showFullExperience && !isLucyActive
}
